import * as React from "react";
import { BooleanInput, Edit, EditProps, SimpleForm, TextInput } from "react-admin";

const ReviewEdit = (props: EditProps) => {
  return (
    <Edit {...props}>
      <SimpleForm style={{ display: "flex", width: "100%" }}>
        <TextInput fullWidth source="name" />
        <TextInput fullWidth source="text" />
        <BooleanInput fullWidth source="accepted" />
      </SimpleForm>
    </Edit>
  );
};

export default ReviewEdit;
